export default __webpack_public_path__ + "static/media/e2.97b0d9f5.png";